import {connect} from "react-redux"
import State from "../../../../models/State"
import {getSearchCategoryThumbnail} from "../../../../utils/getSearchCategoryThumbnail"

export const mapStateToProps = (state: State, ownProps: any) => {
    const {
        search: {
            searchCategory: {id: searchCategoryId},
            searchCategoryThumbnails,
            currentBreakpoint,
            showCategoryThumbnails,
        },
    } = state

    const {
        filterName,
        facet: {v},
    } = ownProps
    const imageObject =
        showCategoryThumbnails && filterName !== "feat"
            ? getSearchCategoryThumbnail(
                  searchCategoryThumbnails,
                  searchCategoryId,
                  filterName,
                  v.replace(`${filterName}:`, ""),
                  currentBreakpoint,
              )
            : null
    return {
        imagePath: imageObject?.imagePath,
        thumbnailSize: imageObject?.size,
    }
}

export default connect(mapStateToProps)
